import { getRailsClient } from "../../client";

export type EmailTemplateItem = {
  position?: number | string;
  text: string;
  textAbove?: string;
  type: string;
  divider?: boolean;
  centered?: boolean;
};

export const activateEmailNotifications = async () => {
  try {
    const API = "/api/internal_api/v1/admin/settings/activate";
    await getRailsClient().put(API, { name: "email_notifications" });
  } catch (error) {
    console.error("Error activating email notifications:", error);
    throw error;
  }
};

export const disableEmailNotifications = async () => {
  try {
    const API = "/api/internal_api/v1/admin/settings/disable";
    await getRailsClient().put(API, { name: "email_notifications" });
  } catch (error) {
    console.error("Error disabling email notifications:", error);
    throw error;
  }
};

export const updateEmailFrequency = async (frequency: string) => {
  try {
    const API = "/api/internal_api/v1/admin/settings/set";
    await getRailsClient().put(API, { name: "update_frequency", value: frequency });
  } catch (error) {
    console.error("Error updating email frequency:", error);
    throw error;
  }
};

export const getEmailTemplates = async () => {
  try {
    const API = "/api/internal_api/v1/admin/custom_emails";
    const { data } = await getRailsClient().get(API);
    return data;
  } catch (error) {
    console.error("Error fetching email templates:", error);
    throw error;
  }
};

export const updateEmailTemplate = async ({
  id,
  template,
}: {
  id: number;
  template: EmailTemplateItem[];
}) => {
  try {
    const API = `/api/internal_api/v1/admin/custom_emails/${id}`;
    const { data } = await getRailsClient().put(API, { template });
    return data;
  } catch (error) {
    console.error("Error updating email template:", error);
    throw error;
  }
};

export const sendTestEmail = async ({
  email,
  templateName,
}: {
  email: string;
  templateName: string;
}) => {
  try {
    const API = "/api/internal_api/v1/admin/custom_emails/send_email";
    await getRailsClient().post(API, { email, template_name: templateName });
  } catch (error) {
    console.error("Error sending test email:", error);
    throw error;
  }
};

export const restoreDefaultTemplate = async (id: number) => {
  try {
    const API = `/api/internal_api/v1/admin/custom_emails/${id}/restore`;
    const restored = await getRailsClient().put(API);
    return restored;
  } catch (error) {
    console.error("Error restoring default email template:", error);
    throw error;
  }
};

export const changeActiveStatus = async ({
  ids,
  activated,
}: {
  ids: number[];
  activated: boolean;
}) => {
  try {
    const API = "/api/internal_api/v1/admin/custom_emails/activate";
    await getRailsClient().put(API, { ids, activated });
  } catch (error) {
    console.error("Error changing email template status:", error);
    throw error;
  }
};
